import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { Panel, Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Redux
import { connect } from 'react-redux';

import { getDynamicTitle } from '../../helpers/GetDynamicItemName/getDynamicName';

// Component
import ResponseItem from './ResponseItem';
import Avatar from '../Avatar/Avatar';
import Link from '../Link/Link';
import { dateFormat } from '../../config';

// Locale
import messages from '../../locale/jsonMessages';
import StarRating from '../StarRating/StarRating';

import cs from '../../components/commonStyle.css';
import s from './Reviews.css';
class ReviewItemAboutYou extends React.Component {

	static propTypes = {
		formatMessage: PropTypes.any,
		picture: PropTypes.string,
		firstName: PropTypes.string,
		lastName: PropTypes.string,
		profileId: PropTypes.number,
		reviewContent: PropTypes.string,
		createdAt: PropTypes.string,
		response: PropTypes.object,
		otherUserResponse: PropTypes.bool,
		showUserName: PropTypes.bool,
		otherUserName: PropTypes.string,
		otherUserProfileId: PropTypes.number,
		isAdmin: PropTypes.bool,
		siteName: PropTypes.string
	};

	static defaultProps = {
		response: null,
		showUserName: false
	};

	render() {
		const { firstName, lastName, profileId, picture, otherUserName, otherUserProfileId, isAdmin, listData, locale } = this.props;
		const { reviewContent, createdAt, response, otherUserResponse, showUserName, siteName, rating, showReviewName } = this.props;
		const { reservationData, dynamicListTitle } = this.props
	let date = moment(parseInt(createdAt)).format('L');
		const { formatMessage } = this.props.intl;

		let isGuestImage = response && response.authorData && response.authorData.picture;
		let isGuestProfileId = response && response.authorData && response.authorData.profileId;
		let showAvatar = showUserName == false ? picture : isGuestImage;
		// let isProfileId = showUserName == false ? profileId : isGuestProfileId;
		let isProfileId, listTitle, dynamicTitle;
		if (!showUserName) {
			isProfileId = profileId
		} else {
			isProfileId = isGuestProfileId
		}

		listTitle = reservationData.listTitle


		dynamicTitle = getDynamicTitle({ data: dynamicListTitle, locale, id: listData?.id });


		return (
			<li className={cx(cs.paddingBottom4)}>
				<div className={cx(s.listAvatarGrid, cs.reviewsContainer)}>
					<div className={cx(cs.reviewsYourItemsOne, cs.reviewsYourLs)}>
						{
							!isAdmin && <div className={cx(s.textCenter, 'reviewsId')} >
								<Avatar
									source={picture}
									title={firstName}
									className={s.profileAvatar}
									withLink
									linkClassName={cx(cs.commonProfileAvatarLink, s.noBackground)}
									profileId={profileId}
								/>
							</div>
						}
						{
							isAdmin && <div className={cx(s.textCenter, cs.commonProfileAvatarLink, s.reviewYoursAdminImg, 'reviewsId')} >
								<Avatar
									source={'../../../adminAvatar.png'}
									title={formatMessage(messages.verifiedBy) + ' ' + siteName}
									className={cx(s.profileAvatar, s.noBackground)}
									staticImage
								/>
							</div>
						}
					</div>
					<div className={cx(s.listDeatilsGrid, cs.reviewsYourItemsTwo, cs.rightBg, 'rightBgRTL', 'reviewDeatilsGridRTL', 'bgBlackTwo', 'dashRightBg')}>
						<div className={cx(cs.dFlexColumn)}>
							{
								showUserName && <span className={cx(cs.writtenReviewTitle)}>
									{listData &&
										<>
											<FormattedMessage {...messages.youHadReviewsFor} />{' '}
											<a href={"/cars/" + listData.id} target={"_blank"} className={cx(cs.reviewTitleLink, cs.commonContentText)}>{dynamicListTitle ? dynamicTitle : (listTitle ? listTitle : listData.title)}</a>
										</>
									}
									{!listData &&
										<FormattedMessage {...messages.notAvailable} />
									}
								</span>
							}

							{
								isAdmin && <div className={cx(s.guestName, cs.writtenReviewTitle)}>
									{formatMessage(messages.verifiedBy) + ' ' + siteName}
								</div>
							}

							{
								!isAdmin && !showUserName &&
								<div className={cx(cs.writtenReviewTitle)}>

									{listData &&
										<>
											{firstName}<span className={cx(cs.reviewHeadingColor)}>{' '}<FormattedMessage {...messages.sReview} /></span>
											<a href={"/cars/" + listData.id} target={"_blank"} className={cx(cs.reviewTitleLink, cs.commonContentText)}>{" "}{dynamicListTitle || listTitle || listData.title}</a>
										</>
									}
									{!listData &&
										<FormattedMessage {...messages.notAvailable} />
									}
								</div>
							}
							{
								reviewContent && <div className={cx(cs.reviewFlex, cs.dFlex, 'reviewStarSection')}>
									<StarRating className='smallStarRatingAdjust' />
									<div>{rating}</div>
									<span className={cx(cs.dotCss)}></span>
									<div className={cx(s.dateReviewCss, 'textWhite', 'dateReviewCssRTL')}>{date}</div>
								</div>
							}
							<p className={cx(cs.reviewPara, cs.commonMediumText, s.contentTop, { [s.noResponse]: !response })}>
								{
									reviewContent && (reviewContent.trim()).split("\n").map(function (content, index) {
										return (
											<span key={index}>
												{content}
												<br />
											</span>
										)
									})
								}
							</p>
							{
								response && <ResponseItem
									data={response}
									otherUserResponse={otherUserResponse}
									date={date}
									showReviewName={showReviewName}
								/>
							}

						</div>
					</div>
				</div>
			</li>
		);
	}
}

const mapState = state => ({
	siteName: state.siteSettings.data.siteName,
	dynamicListTitle: state?.dynamicListTitles?.data?.dynamicListTitle,
	locale: state.intl.locale
});

const mapDispatch = {
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ReviewItemAboutYou)));
